import { ICommonEntityObject } from "../interfaces/ICommonEntityObject.interface";

export class AbstractCommonMethod<T extends ICommonEntityObject<any>> {
	compareCommonEntity(a: T, b: T) {
		return a.id === b.id;
	}
}